import type { OfferView } from "../api/client.js";

/**
 * The bookmaker's own page for a bet.
 *
 * It resolves the offer matching the book being recommended and no other.
 * Linking to a different book would mean re-finding the market by hand -
 * the work the link exists to remove - and worse, invites placing at a price
 * that was never checked against the minimum.
 *
 * A book that published no URL gets nothing back rather than a guess. Dabble
 * supplies none at all, so an absent link is the normal case and not a fault.
 */
export function bookmakerLink(
  bookmaker: string,
  offers: readonly OfferView[] | undefined,
): string | null {
  const exact = offers?.find(
    (offer) => offer.bookmaker === bookmaker && offer.url !== null,
  );
  return exact?.url === null || exact?.url === undefined
    ? null
    : appLink(exact.url);
}

/**
 * Rewrites a book's web link to one its iPhone app claims, so a tap opens the
 * app (already signed in) instead of the website. Unibet's app only claims
 * /betting/sports/event/live/* among game pages (its apple-app-site-
 * association, checked 3 Nov 2026), so pre-match games use that path too.
 */
export function appLink(url: string): string {
  return url.replace(
    /^(https:\/\/www\.unibet\.com\.au\/betting\/sports\/event)\/(\d+)/,
    "$1/live/$2",
  );
}
